import React from 'react';
import { UserAvatar } from '../../../../../shared/UserAvatar';
import {
    roleBadgeClassMap,
    statusClassMap,
} from '../helpers/settingsUsersManagementConfig';

export const SettingsUsersTable = ({
    users,
    isLoading,
    total,
    savingUserId,
    currentUserId,
    onEdit,
    onResendInvitation,
    onOpenToggleDialog,
}) => {
    return (
        <div className="table-responsive settings-users-table-wrap">
            <table className="table mb-0 align-middle settings-users-table">
                <thead>
                    <tr>
                        <th>Usuario</th>
                        <th>Email</th>
                        <th>Grupos</th>
                        <th>Rol</th>
                        <th>Estatus</th>
                        <th style={{ width: '320px' }}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && (
                        <tr>
                            <td colSpan={6} className="text-center text-muted py-3">Cargando usuarios...</td>
                        </tr>
                    )}

                    {!isLoading && users.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center text-muted py-3">No hay usuarios para mostrar.</td>
                        </tr>
                    )}

                    {!isLoading && users.map((user) => (
                        <tr key={user._id}>
                            <td>
                                <div className="settings-user-cell">
                                    <UserAvatar
                                        name={user?.name || user?.email || 'Usuario'}
                                        photoUrl={user?.photoUrl || ''}
                                        className="settings-user-avatar"
                                        fallbackClassName="settings-user-avatar settings-user-avatar--fallback"
                                    />
                                    <div className="settings-user-cell__meta">
                                        <div className="fw-semibold text-dark">{user?.name || '-'}</div>
                                        <div className="d-inline-flex align-items-center gap-2 fs-12 text-muted">
                                            <i
                                                className={`rounded-circle ${user?.available === false ? 'bg-danger' : 'bg-success'}`}
                                                style={{ width: '8px', height: '8px', display: 'inline-block' }}
                                            />
                                            <span>{user?.available === false ? 'No disponible' : 'Disponible'}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td>{user?.email || '-'}</td>
                            <td>
                                {Array.isArray(user?.groups) && user.groups.length > 0 ? (
                                    <div className="d-flex flex-wrap gap-1">
                                        {user.groups.slice(0, 2).map((groupName) => (
                                            <span key={`${user._id}-${groupName}`} className="badge bg-soft-primary text-primary">{groupName}</span>
                                        ))}
                                        {user.groups.length > 2 && (
                                            <span className="badge bg-soft-secondary text-secondary">+{user.groups.length - 2}</span>
                                        )}
                                    </div>
                                ) : (
                                    <span className="text-muted fs-12">Sin grupos</span>
                                )}
                            </td>
                            <td>
                                <span className={`badge ${roleBadgeClassMap[user?.role] || 'bg-soft-secondary text-secondary'}`}>{user?.role || '-'}</span>
                            </td>
                            <td>
                                <span className={`badge ${statusClassMap[String(Boolean(user?.active))] || 'bg-soft-secondary text-secondary'}`}>
                                    {user?.active ? 'Activo' : 'Inactivo'}
                                </span>
                            </td>
                            <td>
                                <div className="d-flex gap-2">
                                    <button type="button" className="btn btn-light-brand btn-sm" onClick={() => onEdit(user)}>Editar</button>
                                    {!user?.active && (
                                        <button
                                            type="button"
                                            className="btn btn-light-warning btn-sm"
                                            onClick={() => onResendInvitation(user)}
                                            disabled={savingUserId === user._id}
                                        >
                                            {savingUserId === user._id ? 'Enviando...' : 'Reenviar invitación'}
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className={`btn btn-sm ${user?.active ? 'btn-light-danger' : 'btn-success'}`}
                                        onClick={() => onOpenToggleDialog(user)}
                                        disabled={savingUserId === user._id || currentUserId === user._id}
                                    >
                                        {savingUserId === user._id ? 'Procesando...' : user?.active ? 'Desactivar' : 'Activar'}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {!isLoading && users.length > 0 && (
                <div className="d-flex justify-content-end px-3 py-2 border-top text-muted fs-12">
                    Mostrando {users.length} de {total}
                </div>
            )}
        </div>
    );
};
